import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import { mainServices, companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function ErhvervPrivatPage() {
  return (
    <>
      <SEO
        title="Erhverv & privat | Hovendals"
        description="Hos Hovendals hjælper vi både erhverv og private kunder med funktionelle og æstetiske løsninger til uderummet i hele landet."
        ogImage="/_assets/485170711-1308137817341082-5036954073090041011-n-6.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/485170711-1308137817341082-5036954073090041011-n-6.jpg", "width=1600,quality=80,format=auto")}
            alt="Erhverv & privat"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-users" aria-hidden="true"></i>
              <span>Hele Danmark</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Erhverv & privat
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Hos Hovendals tilbyder vi skræddersyede løsninger til både private grundejere og virksomheder, institutioner og boligforeninger i hele landet.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-3">
            <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Vores arbejdsområder</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
              Vi bygger til dit behov
            </h2>
            <p className="text-slate-600 text-base">
              Vælg et arbejdsområde herunder for at læse mere om de specifikke løsninger, materialer og muligheder.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {mainServices.map((service) => (
              <div
                key={service.title}
                className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-lg transition-all flex flex-col group"
              >
                <div className="relative h-56 overflow-hidden bg-slate-100">
                  <img
                    src={imageUrl(service.image, "width=600,quality=80,format=auto")}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 to-transparent"></div>
                  <h3 className="absolute bottom-4 left-4 right-4 text-2xl font-bold text-white">
                    {service.title}
                  </h3>
                </div>

                <div className="p-6 flex-grow flex flex-col justify-between space-y-4">
                  <p className="text-sm text-slate-600 leading-relaxed">
                    {service.desc}
                  </p>

                  <div className="space-y-2 pt-2 border-t border-slate-100">
                    <div className="text-xs font-bold uppercase tracking-wider text-slate-400">
                      Varianter:
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {service.sublinks.map((sub) => (
                        <Link
                          key={sub.label}
                          to={sub.href}
                          className="px-2.5 py-1 rounded bg-slate-100 hover:bg-[#004FA4]/10 text-slate-800 hover:text-[#004FA4] text-xs font-semibold transition-colors"
                        >
                          {sub.label}
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="pt-2">
                    <Link
                      to={service.href}
                      className="inline-flex items-center gap-2 text-sm font-bold text-[#004fa4] hover:text-[#183e7f] transition-colors"
                    >
                      <span>Læs mere om {service.title.toLowerCase()}</span>
                      <i className="fa-sharp fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dialog info block */}
          <div className="mt-16 p-8 rounded-2xl bg-slate-900 text-white flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="space-y-2 text-center md:text-left">
              <h3 className="text-xl font-bold text-white">
                Har du en forespørgsel eller brug for information?
              </h3>
              <p className="text-sm text-slate-300">
                Send os en besked herunder, så følger vi op hurtigst muligt.
              </p>
            </div>
            <a
              href={`tel:${companyInfo.phoneFormatted}`}
              className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shrink-0 transition-all flex items-center gap-2"
            >
              <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
              <span>Ring {companyInfo.phone}</span>
            </a>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />
    </>
  );
}
